import List from "./List";
import { NotificationsIcon } from "../icons";

const config = {
  options: {
    group: "dashboard",
    roles: ["admin", "user", "region", "tro", "readonly"],
  },
  icon: NotificationsIcon,
  list: List,
};

export default config;
